import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { copyEvaluations, createEvaluation, getEvaluations, getSemesterEvaluations, updateEvaluation } from '../api/evaluationCourse.api';
import { IEvaluation, IEvaluationReq, IGetEvaluations } from '../models/evaluationCourse.model';

interface IEvaluationState {
  evaluations: IEvaluation[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IEvaluationState = {
  evaluations: [],
  isLoading: false
};

const evaluationSlicer = createSlice({
  name: 'evaluation',
  initialState,
  reducers: {
    getEvaluationsStart: (state: IEvaluationState) => {
      state.evaluations = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getEvaluationsSuccess: (state: IEvaluationState, action: PayloadAction<IGetEvaluations>) => {
      state.evaluations = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getEvaluationsFailure: (state: IEvaluationState, action: PayloadAction<AxiosError|string>) => {
      state.evaluations = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IEvaluationState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IEvaluationState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IEvaluationState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: IEvaluationState) => {
      state.isLoading = false;
      state.error = undefined;
    }
  }
});

export const {
  getEvaluationsStart,
  getEvaluationsSuccess,
  getEvaluationsFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess
} = evaluationSlicer.actions;

export default evaluationSlicer.reducer;

export const doGetEvaluations = (courseCode: number): any => async (dispatch: any) => {
  try {
    dispatch(getEvaluationsStart());
    const response = await getEvaluations(courseCode);
    dispatch(getEvaluationsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getEvaluationsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

// 교육과정 - 맵핑된 평가항목
export const doGetSemesterEvaluations = (semesterCourseCode: number): any => async (dispatch: any) => {
  try {
    dispatch(getEvaluationsStart());
    const response = await getSemesterEvaluations(semesterCourseCode);
    dispatch(getEvaluationsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getEvaluationsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateEvaluation = (courseCode: number, data: IEvaluationReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createEvaluation(courseCode, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doUpdateEvaluation = (courseEvaluationCode: number, data: IEvaluationReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await updateEvaluation(courseEvaluationCode, data);
    dispatch(updateSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCopyEvaluations = (courseCode: number, targetCourseCode: number): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await copyEvaluations(courseCode, targetCourseCode);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
